/* Collapsible disclosure for the B139 "what we inspect" list.
 *
 * The markup ships expanded so the list is readable when this file never runs.
 * Collapsing therefore happens here, on load, rather than in the template.
 */

(() => {
  const collapse = (panel, toggle, expanded) => {
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  };

  const init = (scope) => {
    (scope || document).querySelectorAll('[data-b139-disclosure]').forEach((root) => {
      if (root.dataset.b139DisclosureReady) return;
      root.dataset.b139DisclosureReady = 'true';

      const toggle = root.querySelector('[data-b139-disclosure-toggle]');
      const panel = root.querySelector('[data-b139-disclosure-panel]');
      if (!toggle || !panel) return;

      collapse(panel, toggle, false);

      toggle.addEventListener('click', () => {
        collapse(panel, toggle, toggle.getAttribute('aria-expanded') !== 'true');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
